module.exports = __webpack_public_path__ + "img/Dusky farmerfish.ab020c55.png";